export const SEPARATOR1 = "SEPARATOR1";
export const SEPARATOR2 = "SEPARATOR2";

type PaginationResult = (number | "SEPARATOR1" | "SEPARATOR2")[];

const buildPaginationArray = (size: number, start = 1) =>
  Array.from({ length: size }, (v, k) => k + start);

export function getPaginationItems(
  currentPage: number,
  lastPage: number,
  maxLength: number
): PaginationResult {
  // handle lastPage less than maxLength
  if (lastPage <= maxLength) {
    return buildPaginationArray(lastPage);
  }

  // handle ellipsis logics

  const firstPage = 1;
  const confirmedPagesCount = 3;
  const deductedMaxLength = maxLength - confirmedPagesCount;
  const sideLength = deductedMaxLength / 2;

  // handle ellipsis in the middle
  if (
    currentPage - firstPage < sideLength ||
    lastPage - currentPage < sideLength
  ) {
    const left = buildPaginationArray(sideLength + firstPage, 1);
    const right = buildPaginationArray(sideLength + 1, lastPage - sideLength);
    return [...left, SEPARATOR1, ...right];
  }

  // handle two ellipsis
  else if (
    currentPage - firstPage >= deductedMaxLength &&
    lastPage - currentPage >= deductedMaxLength
  ) {
    const deductedSideLength = sideLength - 1;

    const middle = buildPaginationArray(
      deductedMaxLength - 1,
      currentPage - deductedSideLength
    );
    return [1, SEPARATOR1, ...middle, SEPARATOR2, lastPage];
  }

  // handle ellipsis not in the middle
  else {
    const res: PaginationResult = [];
    const isNearFirstPage = currentPage - firstPage < lastPage - currentPage;
    let remainingLength = maxLength;

    if (isNearFirstPage) {
      for (let m = 1; m <= currentPage + 1; m++) {
        res.push(m);
        remainingLength -= 1;
      }

      res.push(SEPARATOR1);
      remainingLength -= 1;

      for (let n = lastPage - (remainingLength - 1); n <= lastPage; n++) {
        res.push(n);
      }
    } else {
      for (let o = lastPage; o >= currentPage - 1; o--) {
        res.unshift(o);
        remainingLength -= 1;
      }

      res.unshift(SEPARATOR1);
      remainingLength -= 1;

      for (let p = remainingLength; p >= 1; p--) {
        res.unshift(p);
      }
    }
    return res;
  }
}
